import React, { useState } from "react";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Style from "./ChoosePPLForTransaction.module.css";
import Search from "antd/lib/input/Search";
import { userSearchForTransactionAPI } from "../../Api/BarestServices";
import { errorToast } from "../../Toast/Toast";
import { Alert } from "antd";
import UserDetailCard from "./UserDetailCard/UserDetailCard";
const ChoosePPLForTransaction = () => {
  const [loadingState, setLoadingState] = useState(false);
  const [userListState, setUserListState] = useState();
  const onSearch = (e) => {
    const phoneRegex = /^09\d{9}$/;

    if (!phoneRegex.test(e)) {
      errorToast("شماره وارد شده معتبر نیست.");
      return;
    }

    setLoadingState(true);
    userSearchForTransactionAPI({ phone: e }, (res) => {
      if (res.status === 1) {
        setUserListState(res.list);
      } else {
        errorToast(res.message);
      }
      setLoadingState(false);
    });
  };
  return (
    <div style={{ width: "100%", maxWidth: "950px", margin: "1px auto",padding:'0.5rem 1rem' }}>
      <BurgerMenuTitle title={"انتقال مبلغ کیف پول"} />
      <div className={Style.PageHolder}>
        <img
          src="/Assets/Images/Menu/transactionToOther.svg"
          alt="انتقال اعتبار"
          className={Style.ImageTransaction}
        />
        <label htmlFor="">شماره کاربر</label>
        <Search
          placeholder="شماره کاربر را وارد کنید"
          enterButton="جستجو"
          size="large"
          type="number"
          maxLength={11}
          onSearch={onSearch}
          loading={loadingState}
        />
      </div>
      {userListState?.length === 0 ? (
        <Alert
          showIcon
          type="warning"
          style={{
            direction: "rtl",
            fontFamily: "iran-sans-num",
            margin: "1rem",
          }}
          message="کاربر با این شماره یافت نشده"
        />
      ) : (
        userListState?.map((item) => {
          return <UserDetailCard key={item.id} userData={item}/>;
        })
      )}
    </div>
  );
};

export default ChoosePPLForTransaction;
